/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Button, DialogActions } from "@mui/material";

const ImageDeleteDialogActions = (props) => {

    const {
        handleCancel,
        handleDelete,
        handleRemove,
        deleteType
    } = props;

    return (
        <Fragment>
            <DialogActions>
                <Button variant='outlined' color='secondary' onClick={handleCancel}>
                    Cancel
                </Button>

                {deleteType === "DELETE" && (
                    <Button variant='contained' color='warning' onClick={handleDelete}>
                        Delete
                    </Button>
                )}
                {deleteType === "REMOVE" && (
                    <Button variant='contained' color='secondary' onClick={handleRemove}>
                        Remove
                    </Button>
                )}
            </DialogActions>
        </Fragment>
    );
};

export { ImageDeleteDialogActions };
